module.exports = __webpack_public_path__ + "zvetseni-prsou_13_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_13_after.jpg
// module id = 1299
// module chunks = 0